export const selectOptionsJobGroup = [
  {
    name: 'مشاغل تجاری و فروش',
    value: 'G1',
  },
  {
    name: 'خدماتی',
    value: 'G2',
  },
  {
    name: 'امور حقوقی و اداری',
    value: 'G3',
  },
  {
    name: 'آموزشی و تربیتی',
    value: 'G4',
  },
  {
    name: 'سلامت و روان',
    value: 'G5',
  },
  {
    name: 'صنعتی و فنی',
    value: 'G6',
  },
  {
    name: 'تولیدی و صنایع دستی',
    value: 'G7',
  },
  {
    name: 'فناوری اطلاعات و کسب و کار اینترنتی',
    value: 'G8',
  },
  {
    name: 'بازارهای مالی و امور بانکی',
    value: 'G9',
  },
  {
    name: 'مدیریت و فرماندهی',
    value: 'G10',
  },
  {
    name: 'فرهنگ و هنر',
    value: 'G11',
  },
  {
    name: 'کارآفرینی',
    value: 'G12',
  },
];

export const selectOptionsPVQ = [
  {
    name: 'خود رهبری',
    value: 'A1',
  },
  {
    name: 'هیجان‌خواهی',
    value: 'A2',
  },
  {
    name: 'لذت‌جویی',
    value: 'A3',
  },
  {
    name: 'موفقیت',
    value: 'A4',
  },
  {
    name: 'قدرت',
    value: 'A5',
  },
  {
    name: 'امنیت',
    value: 'A6',
  },
  {
    name: 'هم‌نوایی',
    value: 'A7',
  },
  {
    name: 'سنت‌گرایی',
    value: 'A8',
  },
  {
    name: 'خیرخواهی',
    value: 'A9',
  },
  {
    name: 'جهان‌نگری',
    value: 'A10',
  },
];

export const selectOptionsClifton = [
  {
    name: 'اجرایی',
    value: 'EG1',
  },
  {
    name: 'تاثیرگزاری',
    value: 'EG2',
  },
  {
    name: 'برقراری ارتباط',
    value: 'EG3',
  },
  {
    name: 'تفکرراهبردی',
    value: 'EG4',
  },
];

export const ECliftonList = [
  {
    name: 'کامجو',
    value: 'E1',
    parentValue: 'EG1',
  },
  {
    name: 'عملگرا',
    value: 'E2',
    parentValue: 'EG2',
  },
  {
    name: 'سازگار',
    value: 'E3',
    parentValue: 'EG3',
  },
  {
    name: 'تحلیلگر',
    value: 'E4',
    parentValue: 'EG4',
  },
  {
    name: 'گرداننده',
    value: 'E5',
    parentValue: 'EG1',
  },
  {
    name: 'ارزشمدار',
    value: 'E6',
    parentValue: 'EG1',
  },
  {
    name: 'فرمانده',
    value: 'E7',
    parentValue: 'EG2',
  },
  {
    name: 'سخنور',
    value: 'E8',
    parentValue: 'EG2',
  },
  {
    name: 'رقابت‌جو',
    value: 'E9',
    parentValue: 'EG2',
  },
  {
    name: 'پیوسته‌نگر',
    value: 'E10',
    parentValue: 'EG3',
  },
  {
    name: 'عدالت طلب',
    value: 'E11',
    parentValue: 'EG1',
  },
  {
    name: 'پیشینه‌گرا',
    value: 'E12',
    parentValue: 'EG4',
  },
  {
    name: 'محتاط',
    value: 'E13',
    parentValue: 'EG1',
  },
  {
    name: 'پرورش‌دهنده',
    value: 'E14',
    parentValue: 'EG3',
  },
  {
    name: 'منظم',
    value: 'E15',
    parentValue: 'EG1',
  },
  {
    name: 'همدل',
    value: 'E16',
    parentValue: 'EG3',
  },
  {
    name: 'متمرکز بر هدف',
    value: 'E17',
    parentValue: 'EG1',
  },
  {
    name: 'آینده‌نگر',
    value: 'E18',
    parentValue: 'EG4',
  },
  {
    name: 'تعارض‌گریز',
    value: 'E19',
    parentValue: 'EG3',
  },
  {
    name: 'ایده‌پرداز',
    value: 'E20',
    parentValue: 'EG4',
  },
  {
    name: 'گردآورنده افراد',
    value: 'E21',
    parentValue: 'EG4',
  },
  {
    name: 'فردنگر',
    value: 'E22',
    parentValue: 'EG3',
  },
  {
    name: 'کلکسیونر',
    value: 'E23',
    parentValue: 'EG4',
  },
  {
    name: 'متفکر',
    value: 'E24',
    parentValue: 'EG4',
  },
  {
    name: 'یادگیرنده',
    value: 'E25',
    parentValue: 'EG4',
  },
  {
    name: 'ایده‌آل‌گرا',
    value: 'E26',
    parentValue: 'EG2',
  },
  {
    name: 'مثبت گرا',
    value: 'E27',
    parentValue: 'EG3',
  },
  {
    name: 'صمیمیت‌طلب',
    value: 'E28',
    parentValue: 'EG3',
  },
  {
    name: 'مسئولیت‌پذیر',
    value: 'E29',
    parentValue: 'EG1',
  },
  {
    name: 'حلال مسائل',
    value: 'E30',
    parentValue: 'EG1',
  },
  {
    name: 'متکی به خود',
    value: 'E31',
    parentValue: 'EG2',
  },
  {
    name: 'اهمیت طلب',
    value: 'E32',
    parentValue: 'EG2',
  },
  {
    name: 'استراتژیک',
    value: 'E33',
    parentValue: 'EG4',
  },
  {
    name: 'اجتماعی',
    value: 'E34',
    parentValue: 'EG2',
  },
];
